import {$equipmentDivaltoCode} from '@/services/'

const module = {
    namespaced: true,

    state: {
        items: [],
        item: {},
        meta: { pagination: {}}
    },

    getters: {
        items: state => state.items,
        item: state => state.item,
        meta: state => state.meta
    },

    mutations: {
        ITEMS(state, value){
            state.items = value
        },

        ITEM(state,value){
            state.item = value
        },

        ADD_ITEM(state, value){
            state.items.push(value)
        },

        META(state, meta){
            state.meta = meta
        },
        
        DELETE(state, id){
          let index = state.items.findIndex(i => i.id == id)
          index > -1 && state.items.splice(index,1)
        },
    },

    actions: {
        all({commit}, {equipmentConfigId, config}){
            return $equipmentDivaltoCode._(equipmentConfigId).all(config).then(function(res){
                let {data, meta} = res.data
                commit('ITEMS', data)
                commit('META', meta)
                return res.data
            }).catch(function(error){
                this.debug('[client.store/actions/all]::Error', error)
            })
        },
        find({ commit }, { equipmentConfigId, id, config }){
          return $equipmentDivaltoCode.show(id, config)
          .then(res => {
            commit('ITEM', res.data.data)
            return res.data.data
          })
        },

        create({ commit }, { equipmentConfigId, payload, config }){
          return $equipmentDivaltoCode._(equipmentConfigId).create(payload, config)
          .then(res => {
            commit('ADD_ITEM', res.data.data)
            return res
          })
        },


        delete({commit}, {equipmentConfigId, id}){
          return $equipmentDivaltoCode._(equipmentConfigId).delete(id)
          .then(() => {
            commit('DELETE', id)
          })
        },

        update({commit}, {equipmentConfigId, id, payload, config}){
          return $equipmentDivaltoCode._(equipmentConfigId).update(id, payload, config).then(res => {
            let { data }= res
            commit('UPDATE', {id, data})
            return res
          })
        },

    }
}

export default module
